import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {BehaviorSubject, Observable} from "rxjs";
import {Restangular} from "ngx-restangular";
import {ProjectAvodCatalogCreateItem} from "@catmodels/avod-catalog/types";
import {GenericLinkedResource} from "@catcore/types/base";
import {extractDataFromModel} from "@catcore/utils";

@Injectable()
export class ProjectAvodCatalogService extends RestHttpService<any>  {

  listSubject = new BehaviorSubject([]);

  constructor(service: Restangular) {
    super('project-avod-catalogs', service);
  }

  /**
   * Initiates the process to create a single AVoDCatalog through the WebAPI
   * @param {any} item
   * @returns {Observable<any>}
   */
  create(item: ProjectAvodCatalogCreateItem): Observable<any> {
    return this.add({
      name: item.name,
      service: item.service._links.self.href,
      removable_media: item.removableMedia ? 'true' : 'false',
      throttle: item.throttle,
      low_water_mark: `${item.lowWaterMark}`,
      trigger_file: item.triggerFile,
      mode: item.mode,
      track_removes: item.trackRemoves ? 'true' : 'false',
      location_id: `${item.locationId}`,
      base_u_r_l: item.baseURL,
      root_path: item.rootPath,
      additional_paths: item.additionalPaths,
      playlists_base_path: '',
    })
      .map((createdCatalog) => {
        return createdCatalog;
      });
  }

  getAvodCatalogs(): Observable<any[]> {
    return this
      .getAll()
      .map((catalogs: any[]) => {
        this.listSubject.next(catalogs);
        return catalogs;
      });
  }

  getAvodCatalog(uri: string) {
    const id = uri.split('/').pop();
    return this.getOne(id);
  }

  getPlaylists(avodCatalog): GenericLinkedResource[] {
    const lookupKey = 'playlists';
    return extractDataFromModel<any>(avodCatalog, lookupKey);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/avod-catalog/services/project-avod-catalog.service.ts